module.exports = __webpack_public_path__ + "img/wechat_bg.fc4c9f84.png";